import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class SettingsTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "parameterColumn", title: "Parameter" },
        { name: "valueColumn", title: "Value" },
      ],
      rows: [
        { parameterColumn: 'Camera name.', valueColumn: 'A camera name can be freely assigned.' },
        { parameterColumn: 'Typ', valueColumn: 'Choose Other' },
        { parameterColumn: 'URL 1.', valueColumn: 'Enter the MJPEG streams of the camera here (see below)' },
        { parameterColumn: 'Extended authentication', valueColumn: 'This option must remain disabled (Basic Authentication)' },
        { parameterColumn: 'Kamera unterwegs sichtbar', valueColumn: 'Should always be activated as this will ensure that the LUPUS XT is used as a proxy and that the TLS 1.2 encrypted connection of the alarm system is used for the live image within the alarm system. A port release for the camera in the router is then also no longer necessary for this live image.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

SettingsTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(SettingsTable)